import React, { useMemo } from "react";

import CommissionModalShell from "./commission-modal-shell";
import CommissionSplitSection from "./commission-split-section";
import { CalcRow, MoneyInput, NoteInput } from "./commission-fields";
import { isSplitValid, toNumber, toSplitForm, toSplitPayload } from "./commission-calc";
import useCommissionEditor from "./use-commission-editor";

const EditProductionCommissionModal = ({ isOpen, onClose, trip, breakdown, onSaved }) => {
  const initialForm = useMemo(
    () => ({
      adjustment: breakdown?.production?.adjustment ?? 0,
      note: breakdown?.production?.note || "",
      split: toSplitForm(breakdown?.production?.split),
    }),
    [breakdown]
  );

  const { form, updateForm, dirty, salesReps, repsLoading, saving, save } = useCommissionEditor({
    isOpen,
    tripId: trip?._id,
    section: "production",
    initialForm,
    onSaved,
    onClose,
  });

  const gross = toNumber(breakdown?.gross);
  const preSplit = gross + toNumber(form.adjustment);
  const canSave = dirty && isSplitValid(form.split);

  const handleSave = () =>
    save({
      adjustment: toNumber(form.adjustment),
      note: form.note.trim(),
      split: toSplitPayload(form.split),
    });

  return (
    <CommissionModalShell
      isOpen={isOpen}
      title="Edit Production Commission"
      trip={trip}
      dirty={dirty}
      canSave={canSave}
      saving={saving}
      onSave={handleSave}
      onClose={onClose}
      testId="edit-production-commission-modal"
    >
      <table className="tv-table tv-commission-table">
        <tbody>
        <CalcRow label="Gross Commission" value={gross} testId="edit-production-gross"/>
        <CalcRow label="Adjustment">
          <MoneyInput
            value={form.adjustment}
            onChange={(adjustment) => updateForm({ adjustment })}
            testId="edit-production-adjustment"
          />
        </CalcRow>
        <CalcRow
          label={form.split ? "Pre-split Prod Commission" : "Final Prod Commission"}
          value={preSplit}
          total
          testId="edit-production-pre-split"
        />
        </tbody>
      </table>

      <NoteInput value={form.note} onChange={(note) => updateForm({ note })} testId="edit-production-note"/>

      <CommissionSplitSection
        title="Split Production Commission"
        finalLabel="Final Prod Comm"
        split={form.split}
        onChange={(split) => updateForm({ split })}
        salesReps={salesReps}
        repsLoading={repsLoading}
        owner={trip?.owner}
        preSplit={preSplit}
        testIdPrefix="edit-production"
      />
    </CommissionModalShell>
  );
};

export default EditProductionCommissionModal;
